function Address({ city = "", street = "", zipCode = "" }) {
  this.city = city;
  this.street = street;
  this.zipCode = zipCode;
}

export default Address;
